import { createSlice } from '@reduxjs/toolkit';

const customLogosSlice = createSlice({
	name: 'customLogos',
	initialState: { customLogos: [] },
	reducers: {
		// Uses explicit return instead of Immer mutation style to satisfy
		// the no-param-reassign ESLint rule enforced by ws-scripts.
		customLogosSet(state, action) {
			return { ...state, customLogos: action.payload };
		}
	}
});

export const { customLogosSet } = customLogosSlice.actions;

export default customLogosSlice.reducer;
